import { makeStyles } from '@material-ui/core';
import { centerBoxProps } from 'globals/utils';

export const useStyles = makeStyles(
  ({ palette, spacing, typography, transitions }) => ({
    smsField: {
      '& > div': {
        ...centerBoxProps,
      },
      '& input': {
        fontFamily: typography.fontFamily,
        fontSize: typography.fontSize,
        margin: spacing(0, 1),
        background: palette.common.white,
        border: `1px solid ${palette.grey[200]}`,
        borderRadius: spacing(1),
        transition: transitions.create(['border-color']),
        '&:last-child': {
          border: `1px solid ${palette.grey[200]}`,
          borderRadius: spacing(1),
        },
        '&:hover': {
          border: `1px solid ${palette.grey[300]}`,
        },
        '&:focus': {
          border: `1px solid ${palette.primary.main}`,
          caretColor: palette.common.black,
          '& + input': {
            borderLeft: `1px solid ${palette.grey[200]}`,
          },
          '& + input:hover': {
            borderLeft: `1px solid ${palette.grey[300]}`,
          },
        },
      },
    },
  })
);
